export const ENV = 'production';